import { render } from "./CreateDoctor.vue?vue&type=template&id=13c93559&scoped=true"
import script from "./CreateDoctor.vue?vue&type=script&lang=js"
export * from "./CreateDoctor.vue?vue&type=script&lang=js"

import "./CreateDoctor.vue?vue&type=style&index=0&id=13c93559&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c93559"]])

export default __exports__